// @flow
import React, { PureComponent, Fragment } from 'react';
import type { EventType, EventMatchType } from 'types/Event';
import { getDateFromString, getMonthName } from 'utils/dateUtils';
import { isEventInCalendarTeam } from 'utils/eventUtils';
import EventListElementSimple from 'components/event/EventListElementSimple';
import EventListElementMatch from 'containers/event/EventListElementMatchContainer';

export type StateProps = {
  calendarTeamIds: Array<string>,
};

type Props = {
  event: EventType | EventMatchType,
  isFirst?: boolean,
  from?: string,
} & StateProps;

class EventListElementWrapper extends PureComponent<Props> {
  renderElement() {
    const { from, event: eventProps, calendarTeamIds } = this.props;
    const event: any = eventProps;

    if (isEventInCalendarTeam(calendarTeamIds, event) && event.adversaire) {
      return <EventListElementMatch eventList event={event} from={from} />;
    } else {
      return <EventListElementSimple event={event} />;
    }
  }

  render() {
    const { isFirst, event } = this.props;
    const startDate = getDateFromString(event.startDate);

    return (
      <div className="event-row event-row--large">
        <p className="event__date">
          {isFirst && (
            <Fragment>
              <span className="event__day ft-h2">{startDate.getDate()}</span>
              <br />
              <span className="event__month ft-h6 ft-up">{getMonthName(startDate.getMonth())}</span>
            </Fragment>
          )}
        </p>
        {this.renderElement()}
      </div>
    );
  }
}

export default EventListElementWrapper;
